import { X, Radar, Globe } from "lucide-react";

/* ---- Ícones de marca (SVG simple-icons), mesmo padrão do CampaignModal ---- */
const BRANDS = {
    facebook: { c: "#1877f2", d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" },
    tiktok: { c: "#ffffff", d: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" },
    google: { c: "#4285F4", d: "M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" },
    x: { c: "#ffffff", d: "M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" },
};

function BrandIcon({ brand, size = 22 }) {
    // Kwai não tem path confiável -> monograma laranja (mesmo do CampaignModal)
    if (brand === "kwai") {
        return (
            <span
                style={{ width: size, height: size, fontSize: size * 0.62 }}
                className="inline-flex items-center justify-center rounded bg-[#FF5000] text-white font-bold leading-none"
            >K</span>
        );
    }
    const it = BRANDS[brand];
    if (!it) return <Globe size={size} />;
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill={it.c} aria-hidden="true">
            <path d={it.d} />
        </svg>
    );
}

const PLATFORMS = [
    { id: "facebook", label: "Facebook", desc: "Pixel & Conversions API", brand: "facebook", ready: true },
    { id: "tiktok", label: "TikTok", desc: "Events API", brand: "tiktok", ready: true },
    { id: "google", label: "Google Ads", desc: "Conversions API", brand: "google", ready: false },
    { id: "kwai", label: "Kwai Ads", desc: "Events API", brand: "kwai", ready: false },
    { id: "x", label: "X Ads", desc: "Conversions API", brand: "x", ready: false },
];

export default function SelectPlatformForTrackingProfile({ open, onSelectPlatform, onClose }) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center p-2 md:p-4">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
            <div
                className="relative w-full max-w-lg rounded-2xl border border-white/[0.09] bg-[#10141a] p-4 md:p-6 shadow-[0_24px_64px_rgba(0,0,0,0.55)] text-white"
                style={{ maxHeight: "92vh", overflowY: "auto", colorScheme: "dark" }}
            >
                {/* Header */}
                <div className="flex items-start justify-between mb-6 gap-3">
                    <div className="flex items-center gap-3 min-w-0">
                        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[rgba(139,92,246,0.12)] border border-[rgba(139,92,246,0.18)] flex items-center justify-center text-[#a78bfa]">
                            <Radar size={20} />
                        </div>
                        <div className="min-w-0">
                            <h2 className="text-lg font-semibold">Novo Perfil de Rastreamento</h2>
                            <p className="text-sm text-white/50">
                                Escolha a plataforma de anúncios para criar o perfil.
                            </p>
                        </div>
                    </div>
                    <button onClick={onClose} className="action-btn flex-shrink-0" aria-label="Fechar">
                        <X size={18} />
                    </button>
                </div>

                {/* Plataformas */}
                <div className="flex flex-col gap-3">
                    {PLATFORMS.map((p) => {
                        const base = "relative flex items-center text-left gap-3 rounded-xl border p-4 transition w-full";
                        const cls = p.ready
                            ? `${base} border-white/[0.08] bg-white/[0.02] hover:border-[rgba(139,92,246,0.4)] hover:bg-[rgba(139,92,246,0.08)] cursor-pointer`
                            : `${base} border-white/[0.06] bg-white/[0.02] opacity-45 cursor-not-allowed`;
                        return (
                            <button
                                key={p.id}
                                type="button"
                                disabled={!p.ready}
                                onClick={() => { if (p.ready) { onSelectPlatform(p.id); onClose(); } }}
                                className={cls}
                            >
                                {!p.ready && (
                                    <span className="absolute top-2 right-2 text-[9px] px-1.5 py-0.5 rounded-md bg-white/[0.06] text-white/50 font-semibold uppercase tracking-wide">
                                        em breve
                                    </span>
                                )}
                                <span className="w-11 h-11 rounded-xl bg-white/[0.04] flex items-center justify-center flex-shrink-0">
                                    <BrandIcon brand={p.brand} size={22} />
                                </span>
                                <span className="min-w-0">
                                    <span className="block text-sm font-semibold text-white">{p.label}</span>
                                    <span className="block text-[11px] text-white/40">{p.desc}</span>
                                </span>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
